import { cmsHttp } from 'shared/api/mfe-axios';
import { REQUEST, SUCCESS, FAILURE } from 'shared/lib/reducers/action-type.util';
export const ACTION_TYPES = {
    FETCH_CARD_RESTRICTIONS_BY_PRODUCT: 'cardRestriction/FETCH_CARD_RESTRICTIONS_BY_PRODUCT',
    FETCH_CARD_RESTRICTIONS_BY_CARD: 'cardRestriction/FETCH_CARD_RESTRICTIONS_BY_CARD',
    CREATE_CARD_RESTRICTION: 'cardRestriction/CREATE_CARD_RESTRICTION',
    GET_CARD_BY_ID_RESTRICTION: 'cardRestriction/GET_CARD_BY_ID',
    UPDATE_CARD_RESTRICTION: 'cardRestriction/UPDATE_CARD_RESTRICTION',
    DELETE_CARD_RESTRICTION: 'cardRestriction/DELETE_CARD_RESTRICTION',
    RESET: 'cardRestriction/RESET',
};
const apiUrl = 'api/card-restrictions';
const initialState = {
    loading: false,
    errorMessage: null,
    entities: [],
    updating: false,
    updateSuccess: false,
};
const toRestrictionList = (body) => {
    if (Array.isArray(body)) {
        return body;
    }
    if (body != null && typeof body === 'object') {
        const content = body.content;
        if (Array.isArray(content)) {
            return content;
        }
        return [body];
    }
    return [];
};
export default (state = initialState, action) => {
    switch (action.type) {
        case REQUEST(ACTION_TYPES.FETCH_CARD_RESTRICTIONS_BY_PRODUCT):
        case REQUEST(ACTION_TYPES.FETCH_CARD_RESTRICTIONS_BY_CARD):
            return {
                ...state,
                errorMessage: null,
                updateSuccess: false,
                loading: true,
            };
        case REQUEST(ACTION_TYPES.CREATE_CARD_RESTRICTION):
        case REQUEST(ACTION_TYPES.UPDATE_CARD_RESTRICTION):
        case REQUEST(ACTION_TYPES.GET_CARD_BY_ID_RESTRICTION):
        case REQUEST(ACTION_TYPES.DELETE_CARD_RESTRICTION):
            return {
                ...state,
                errorMessage: null,
                updateSuccess: false,
                updating: true,
            };
        case FAILURE(ACTION_TYPES.FETCH_CARD_RESTRICTIONS_BY_PRODUCT):
        case FAILURE(ACTION_TYPES.FETCH_CARD_RESTRICTIONS_BY_CARD):
        case FAILURE(ACTION_TYPES.CREATE_CARD_RESTRICTION):
        case FAILURE(ACTION_TYPES.GET_CARD_BY_ID_RESTRICTION):
        case FAILURE(ACTION_TYPES.UPDATE_CARD_RESTRICTION):
        case FAILURE(ACTION_TYPES.DELETE_CARD_RESTRICTION):
            return {
                ...state,
                loading: false,
                updating: false,
                updateSuccess: false,
                errorMessage: action.payload,
            };
        case SUCCESS(ACTION_TYPES.FETCH_CARD_RESTRICTIONS_BY_PRODUCT):
        case SUCCESS(ACTION_TYPES.FETCH_CARD_RESTRICTIONS_BY_CARD): {
            const list = toRestrictionList(action.payload.data);
            return {
                ...state,
                loading: false,
                entities: list,
            };
        }
        case SUCCESS(ACTION_TYPES.CREATE_CARD_RESTRICTION):
        case SUCCESS(ACTION_TYPES.UPDATE_CARD_RESTRICTION):
        case SUCCESS(ACTION_TYPES.GET_CARD_BY_ID_RESTRICTION):
        case SUCCESS(ACTION_TYPES.DELETE_CARD_RESTRICTION):
            return {
                ...state,
                updating: false,
                updateSuccess: true,
                loading: false,
            };
        case ACTION_TYPES.RESET:
            return {
                ...initialState,
            };
        default:
            return state;
    }
};
const toApiDateField = (value) => {
    if (value == null) {
        return value;
    }
    return value instanceof Date ? value.toISOString() : value;
};
/** Strips valueJson; keeps productId / cardId and rule fields as returned by the form. */
const toApiPayload = (entity, options) => {
    const includeId = options?.includeId ?? false;
    const { id, valueJson: _valueJson, ...rest } = entity;
    const payload = {
        ...rest,
        effectiveFrom: toApiDateField(entity.effectiveFrom),
        effectiveTo: toApiDateField(entity.effectiveTo),
    };
    if (includeId && id != null) {
        return { ...payload, id };
    }
    return payload;
};
const buildRestrictionsQuery = (filters) => {
    if (!filters) {
        return '';
    }
    const parts = [];
    const q = (key, value) => {
        if (value === undefined || value === null) {
            return;
        }
        const s = typeof value === 'string' ? value.trim() : String(value);
        if (s === '') {
            return;
        }
        parts.push(`${key}=${encodeURIComponent(s)}`);
    };
    q('restrictionType.equals', filters.restrictionType);
    q('restrictionMode.equals', filters.restrictionMode);
    if (filters.valueCodeContains?.trim()) {
        q('valueCode.contains', filters.valueCodeContains.trim());
    }
    q('status.equals', filters.status);
    q('appliesToChannel.equals', filters.appliesToChannel);
    q('appliesToCountry.equals', filters.appliesToCountry);
    q('effectiveFrom.greaterThanOrEqual', filters.effectiveFromGte);
    q('effectiveFrom.lessThanOrEqual', filters.effectiveFromLte);
    q('effectiveTo.greaterThanOrEqual', filters.effectiveToGte);
    q('effectiveTo.lessThanOrEqual', filters.effectiveToLte);
    return parts.length ? `?${parts.join('&')}` : '';
};
export const getRestrictionsByProductId = (productId, filters) => ({
    type: ACTION_TYPES.FETCH_CARD_RESTRICTIONS_BY_PRODUCT,
    payload: cmsHttp().get(`${apiUrl}/product/${productId}${buildRestrictionsQuery(filters)}`),
});
export const getRestrictionsByCardId = (cardId, filters) => ({
    type: ACTION_TYPES.FETCH_CARD_RESTRICTIONS_BY_CARD,
    payload: cmsHttp().get(`${apiUrl}/card/${cardId}${buildRestrictionsQuery(filters)}`),
});
export const createEntity = (entity) => async (dispatch) => {
    const body = toApiPayload(entity);
    return dispatch({
        type: ACTION_TYPES.CREATE_CARD_RESTRICTION,
        payload: cmsHttp().post(apiUrl, body),
    });
};
export const updateEntity = (entity) => async (dispatch) => {
    if (entity.id == null) {
        return undefined;
    }
    return dispatch({
        type: ACTION_TYPES.UPDATE_CARD_RESTRICTION,
        payload: cmsHttp().patch(`${apiUrl}/${entity.id}`, toApiPayload(entity, { includeId: true })),
    });
};
export const getEntity = (id) => async (dispatch) => dispatch({
    type: ACTION_TYPES.GET_CARD_BY_ID_RESTRICTION,
    payload: cmsHttp().get(`${apiUrl}/${id}`),
});
export const deleteEntity = (id) => async (dispatch) => dispatch({
    type: ACTION_TYPES.DELETE_CARD_RESTRICTION,
    payload: cmsHttp().delete(`${apiUrl}/${id}`),
});
export const reset = () => ({
    type: ACTION_TYPES.RESET,
});
